import { viewing } from '@/services/utils'
import { computed, ref, watch } from 'vue'

interface column {
	text: string
	icon: string
	isVisible: boolean
}

interface ConnectionColumns {
	instance: column
	responsible: column
	priority: column
	status: column
	price: column
	date: column
	comment: column
	lastReview: column
	changeLog: column
	urlReference: column
	documentReference: column
	risks: column
	serviceProvider: column
	auditCheck: column
}

export const connectionColumns = ref<ConnectionColumns>({
	instance: { text: 'instance', icon: 'bi bi-building', isVisible: true },
	responsible: { text: 'responsible', icon: 'bi bi-person-circle', isVisible: true },
	serviceProvider: { text: 'method.serviceProvider', icon: 'bi bi-person-circle pie5', isVisible: true },
	priority: { text: 'priority', icon: 'bi bi-sort-up', isVisible: true },
	status: { text: 'status.label', icon: 'bi bi-ui-checks-grid', isVisible: true },
	price: { text: 'price', icon: 'bi bi-currency-exchange', isVisible: true },
	auditCheck: { text: 'audit.checks', icon: 'bi bi-clipboard-check', isVisible: false },
	date: { text: 'date.dueDate', icon: 'bi bi-clock', isVisible: true },
	comment: { text: 'misc.comment', icon: 'bi bi-chat-right-text', isVisible: true },
	lastReview: { text: 'lastReview', icon: 'bi bi-calendar-check', isVisible: true },
	changeLog: { text: 'history.label', icon: 'bi bi-clock-history', isVisible: true },
	urlReference: { text: 'reference.url', icon: 'bi bi-link-45deg', isVisible: true },
	documentReference: { text: 'reference.document', icon: 'bi bi-file-earmark-text', isVisible: true },
	risks: { text: 'risk.count', icon: 'bi-exclamation-triangle', isVisible: false },
})

export const visibleConnectionColumns = computed(() =>
	Object.entries(connectionColumns.value).filter(([name, opt]) => {
		if (name === 'risks' && viewing.value === 0) return false
		return opt.isVisible
	}),
)

const STORAGE_KEY = 'connection-columns-visibility'

function saveVisibility() {
	const names = visibleConnectionColumns.value.map(([name]) => name)
	localStorage.setItem(STORAGE_KEY, JSON.stringify(names))
}

function loadVisibility() {
	const json = localStorage.getItem(STORAGE_KEY)
	if (json) {
		try {
			const names = JSON.parse(json) as string[]
			Object.entries(connectionColumns.value).forEach(([name, opt]) => {
				opt.isVisible = names.includes(name)
			})
		} catch {
			// ignore
		}
	}
}

loadVisibility()
watch(connectionColumns, saveVisibility, { deep: true })
